<template>
  <div class="home">
    <div class="layout" :class="{ 'layout-hide-text': spanLeft < 3 }">
      <Row type="flex" style="height: 100%">
        <i-col :span="spanLeft" class="layout-menu-left">
          <div class="layout-logo-left">{{ logo_title }}</div>
          <Menu
            :active-name="router_path"
            theme="dark"
            width="auto"
            :open-names="['admin', curr_service]"
            @on-select="menuSelect"
          >
            <Menu-item name="/apy-dashboard">
              <Icon type="ios-list-box" :size="iconSize"></Icon>
              <span class="layout-text">APY 看板</span>
            </Menu-item>

            <Menu-item name="/admin/strategy">
              <Icon type="logo-android" :size="iconSize"></Icon>
              <span class="layout-text">Strategy 管理</span>
            </Menu-item>

            <Menu-item name="/admin/vault">
              <Icon type="ios-card" :size="iconSize"></Icon>
              <span class="layout-text">Vault 管理</span>
            </Menu-item>

            <Menu-item name="/admin/role">
              <Icon type="md-planet" :size="iconSize"></Icon>
              <span class="layout-text">Index 管理</span>
            </Menu-item>
          </Menu>
        </i-col>
        <i-col :span="spanRight" class="layout-container">
          <div class="layout-header">
            <div class="header-title">{{ menus[curr_subservice] }}</div>
            <div class="header-right">
              <div class="chain-network" v-if="user.network">
                <div class="circle"></div>
                <div class="text">
                  {{ chainInfoMap[user.network].chainName }}
                </div>
              </div>

              <div class="address-box">
                {{ user.address | omit }}
              </div>

              <div
                v-if="user.address"
                :class="['tag-box', isOwner ? 'success-box' : 'error-box']"
              >
                {{ isOwner ? "是 Owner" : "不是 Owner" }}
              </div>

              <Button
                v-if="user.address"
                type="text"
                style="margin-left: 20px"
                @click="logout"
                ghost
                >登出</Button
              >
              <Button
                v-else="user.address"
                type="text"
                style="margin-left: 20px"
                @click="login"
                >连接钱包
              </Button>
            </div>
          </div>
          <div class="layout-content">
            <router-view />
          </div>
          <!-- <div class="layout-copy">2021 &copy; DeCustody</div> -->
        </i-col>
      </Row>
    </div>
  </div>
</template>

<script>
import { chainInfoMap } from "@/utils/tx";

export default {
  name: "home",
  components: {},
  data() {
    return {
      spanLeft: 3,
      spanRight: 21,
      logo_title: "Sentry Gun",
      router_path: "user_manager",
      menus: {
        strategy: "Strategy 管理",
        vault: "Vault 管理",
        role: "Index 管理",
        "apy-dashboard": "APY 看板",
      },
      chainInfoMap: chainInfoMap,
      user: {
        name: localStorage["username"],
        address: null,
        network: "",
      },
      curr_service: this.$route.path.split("/")[1],
      curr_subservice: this.$route.path.split("/")[2],
      isOwner: window.isOwner,
    };
  },
  computed: {
    iconSize() {
      return this.spanLeft === 4 ? 24 : 24;
    },
  },

  async created() {
    console.log("created home");
    console.log(this.$route.path);
    this.router_path = this.$route.path;
  },
  async mounted() {
    this.login();
  },
  watch: {
    $route(to, from) {
      this.router_path = this.$route.path;
    },
    router_path(to, from) {
      this.curr_service = to.split("/")[1];
      this.curr_subservice = to.split("/")[2];
      // console.log(this.curr_service,this.curr_subservice)
    },
  },
  filters: {
    omit(value) {
      if (value) {
        return (
          value.slice(0, 8) +
          "..." +
          value.slice(value.length - 5, value.length)
        );
      }
      return "";
    },
  },
  methods: {
    menuSelect(key) {
      console.log(key);
      this.router_path = key;
      this.$router.push({ path: key }).catch((e) => {
        console.log(e);
      });
    },
    backClick() {
      this.$router.go(-1);
    },

    logout() {
      this.user.address = null;
      this.user.network = null;
    },
    login() {
      this.user.address = window.currAddress;
      this.user.network = window.net;
      // this.isOwner = window.isOwner
    },
  },
};
</script>

<style lang="scss">
@import "./reset.scss";
</style>


<style lang="scss" scoped>
@import "./home.module.scss";
</style>
